module.exports = __webpack_public_path__ + "assets/img/ZT599N-M.ceea6c9f.png";